// Create a class for the element
if (!customElements.get("lwp-quick-buy")) {
  class LwpQuickBuy extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        variantOpen: '.media-variant-open',
        button: ".lwp-quick-buy__button",
        variants: ".product-card-variants",
        close: ".close-card-variants",
        open: ".expand-card-variants",
        cart: "cart-drawer",
      };
      this.isSimpleProduct = false;
      this.simpleVariantId = null;

      this.isAddingToCart = false;
    }

    
    connectedCallback() {
      const _this = this;
      this.initVariantButtons().then(() => {
        _this.attachEvents();
      });
      document.addEventListener("click", function(e) {
        if (!e.target.closest(".lwp-quick-buy")) {
            const variantsElement = _this.querySelector(_this.selectors.variants);
            if (variantsElement) {
              variantsElement.classList.remove("expanded");
            }
        }
      });
    }

    async initVariantButtons() {
      let variants = [];
      const handle = this.dataset.productHandle;
      if (this.dataset.variants && (this.isJSONValid(this.dataset.variants)) ) {
        variants = JSON.parse(this.dataset.variants);
      }
      if (handle) {
        const productContent = await this.getProductContent(handle);
        if (productContent.variants) {
          variants = productContent.variants;
        }
      }
      if (variants.length >= 1) {
        if (variants.length === 1) {
          this.isSimpleProduct = true;
          this.simpleVariantId = variants[0].id;
        }
        const variantsHtml = this.variantsTemplate(variants);
        this.innerHTML += variantsHtml;
        this.attachVariantEvents();
      } else {
        this.querySelector(this.selectors.button).classList.add("hidden");
      }
    }

    attachEvents() {
      this.querySelector(this.selectors.button).classList.remove("hidden");
      this.querySelector(this.selectors.button).addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.isSimpleProduct && this.simpleVariantId) {
          if (window?.lwpEvents?.bundles) {
            this.addBundleProduct(this.simpleVariantId);
            return false;
          }
          if (this.dataset.isCustomizer === "true") {
            window.location.href = `${this.dataset.productUrl}`;
            return false;
          }
          this.addToCart(this.simpleVariantId);
          this.addToCartEvent(e);
          return false;
        }
        this.querySelector(this.selectors.variants).classList.add("expanded");
        return false;
      });

      let variantOpen = this.closest('.product-card').querySelector(this.selectors.variantOpen);
      if(variantOpen) {
        variantOpen.addEventListener('click', () => {
          setTimeout(() => {
            variantOpen.closest('.product-card').querySelector(this.selectors.button).click();
          })
        })
      }
    }

    attachVariantEvents() {
      const _this = this;

      this.querySelector(this.selectors.close).addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        _this.querySelector(_this.selectors.variants).classList.remove("expanded");
        return false;
      });

      this.querySelectorAll(this.selectors.variants).forEach((variant) => {
        variant.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (_this.dataset.isCustomizer === "true") {
            const variantId = e.target.dataset.variantId;
            if (variantId) {
              if (_this.dataset.productUrl.includes('variant')) {
                window.location.href = `${_this.dataset.productUrl.replace(/variant=\d+/, `variant=${variantId}`)}&size=${
                  e.target.dataset.value
                }`;
              } else {
                window.location.href = `${_this.dataset.productUrl}?variant=${variantId}&size=${e.target.dataset.value}`;
              }
              return false;
            }
            window.location.href = `${this.dataset.productUrl}&size=${e.target.dataset.value}`;
            return false;
          }
          const variantId = e.target.dataset.variantId;
          if (variantId) {
            if (window?.lwpEvents?.bundles) {
              this.addBundleProduct(variantId);
              return false;
            }
            this.addToCart(variantId);
            this.addToCartEvent(e);
          }
          return false;
        });
      });
    }

    variantsTemplate = (variants) => {
      let uniqueVariantList = [];
      let buyTitle = "Select a Size";
      const variantsHtml = variants
        .map((variant) => {
          const uniqueVariantOption = variant.size_name || variant.option3 || variant.option2 || variant.option1;
          if (uniqueVariantList.includes(uniqueVariantOption)) {
            return "";
          }
          uniqueVariantList.push(uniqueVariantOption);
          if (variant?.is_default) {
            buyTitle = "";
            return `
            <li role="button" aria-label="0" class="product-card-variant" data-variant-id="${variant.id}" data-value="0">Add to cart</li>
          `;
          }
          if (variant.inventory_quantity > 0 || variant.inventory_policy === "continue") {
            return `
            <li role="button" aria-label="${uniqueVariantOption}" class="product-card-variant" data-variant-id="${variant.id}" data-value="${uniqueVariantOption}">${uniqueVariantOption}</li>
          `;
          } else {
            return `
            <li role="button" aria-label="${uniqueVariantOption}" class="product-card-variant product-card-variant-disabled">${uniqueVariantOption}</li>
          `;
          }
        })
        .join("");

      return `
        <div class="product-card-variants h-stack fd-column">
          <div class="h-stack justify-between items-center">
            <label>${buyTitle}</label>
            <button class="close-card-variants" aria-label="Close card">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" class="icon icon-plus-circle" viewBox="0 0 27 27" fill="none"><circle cx="13.0914" cy="13.0914" r="12.5914" stroke="#DA9FC4"></circle>
                <path d="M13.0916 7.85498C12.8602 7.85498 12.6726 8.04254 12.6726 8.27391V12.6726H8.27391C8.04253 12.6726 7.85498 12.8602 7.85498 13.0916C7.85498 13.3229 8.04253 13.5105 8.27391 13.5105H12.6726V17.9092C12.6726 18.1406 12.8602 18.3281 13.0916 18.3281C13.3229 18.3281 13.5105 18.1406 13.5105 17.9092V13.5105H17.9092C18.1406 13.5105 18.3281 13.3229 18.3281 13.0916C18.3281 12.8602 18.1406 12.6726 17.9092 12.6726H13.5105V8.27391C13.5105 8.04254 13.3229 7.85498 13.0916 7.85498Z" fill="#DA9FC4"></path>
              </svg>
            </button>
          </div>
          <ul class="unstyled-list">
            ${variantsHtml}
          </ul>
        </div>
      `;
    };

    async getProductContent(handle) {
      var response = await fetch(`/products/${handle}?view=collection-json`);

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      var data = await response.json();
      return data;
    }

    addBundleProduct(variantId) {
      const _this = this;
      document.dispatchEvent(
        new CustomEvent("addbundle", {
          detail: {
            productid: _this.dataset.id || _this.dataset.productId || variantId,
            variantid: variantId,
            price: _this.dataset.productPrice,
            image: _this.dataset.productImage,
            bracelet: _this.dataset.isBracelet ? _this.dataset.isBracelet === 'true' : false,
            charm: _this.dataset.isCharm ? _this.dataset.isCharm === 'true' : false,
            title:_this.dataset.productTitle
          },
        })
      );
      this.querySelector(this.selectors.variants).classList.remove("expanded");
    }

    async addToCart(variantId, quantity = 1, properties = {}) {
      // 🔒 Prevent multiple add-to-cart actions
      if (this.isAddingToCart) return;
      this.isAddingToCart = true;

      try {
        if (this.dataset.cartNote && this.dataset.cartNote.trim() !== "") {
          properties["Cart Note"] = this.dataset.cartNote;
        }
        if (this.dataset.mtoWord && this.dataset.mtoWord.trim() !== "") {
          properties["_word"] = this.dataset.mtoWord.trim().toUpperCase();
        }

        const response = await fetch("/cart/add.js", {
          method: "POST",
          body: JSON.stringify({
            id: variantId,
            quantity: quantity,
            properties: properties,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        });

        const json = await response.json();

        if (json.status === 422) {
          return false;
        }

        window.isCartRefreshed = true;

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );

        const drawer = document.querySelector(this.selectors.cart);
        if (drawer) {
          drawer.show();
        }

        this.querySelector(this.selectors.variants).classList.remove("expanded");
      } catch (error) {
        console.error("Add to cart failed", error);
      } finally {
        // 🔓 Always release the lock
        this.isAddingToCart = false;
      }
    }

    disconnectedCallback() {
      // console.log("Custom element Quick-Buy removed.");
    }

    adoptedCallback() {
      // console.log("Custom element Quick-Buy moved to new page.");
    }

    isJSONValid(jsonString) {
      try {
        JSON.parse(jsonString);
        return true;
      } catch (error) {
        return false;
      }
    }

    addToCartEvent(e) {
      //  avoid multiple event triggers
      e.target.disabled = true;
      setTimeout(() => {
        e.target.disabled = false;
      }, 1000);
      console.log('Adding to Cart via Quick Buy');
      const variantId = e?.target?.dataset?.variantId || false;
      const productHandle = e?.target?.dataset?.productHandle || false;
      if (!variantId || !productHandle) {
        return false;
      }
      document.documentElement.dispatchEvent(
        new CustomEvent("customAddToCart", {
          bubbles: true,
          detail: { id: variantId, handle: productHandle, quantity: 1 },
        })
      );
    }
  }
  customElements.define("lwp-quick-buy", LwpQuickBuy);
}